export const LOADING_TAG_PREVIEWS = 'loading tag previews';
export const TAGS_PREVIEW_LOADED = 'tags loaded';
